/* eslint-disable no-unused-vars */
import React, {useState,Fragment} from 'react';
import Navbar from '../../components/Navbar/Navbar'
import Hero5 from '../../components/hero5/Hero5';
import Features2 from '../../components/Features2/Features2';
import About5 from '../../components/about5/about5';
import FunFact2 from '../../components/FunFact2/FunFact2';
import CategorySection from '../../components/CategorySection/CategorySection';
import CourseSectionS2 from '../../components/CourseSectionS2/CourseSectionS2';
import TeamSection from '../../components/TeamSection/TeamSection';
import BlogSection from '../../components/BlogSection/BlogSection';
import Newslatter2 from '../../components/Newslatter2/Newslatter2';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import '../../css/FloatingWindow.css'; 
import { useLanguage } from '../../i18n/LanguageContext';

const HomePage5 = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useLanguage();

    const toggleWindow = () => {
        setIsOpen(!isOpen);
    };

    return (
        <Fragment>
            <Navbar hclass={'wpo-header-style-2'} />
            <Hero5 />
            <About5 />
            <Footer />
            <Scrollbar />

            {/* 悬浮窗按钮 */}
            <div className="floating-button" onClick={toggleWindow}>
                {isOpen ? t('common.close') : t('home.volunteerButton')}
            </div>

            {/* 悬浮窗内容 */}
            {isOpen && (
                <div className="floating-window">
                    <div className="floating-window-header">
                        <h1 className="banner">{t('home.volunteerTitle')}</h1>
                        <button className="close-button" onClick={toggleWindow}>
                            {t('common.close')}
                        </button>
                    </div>
                    <div className="floating-window-copy">
                        {t('home.volunteerLines').map((line) => <p key={line}>{line}</p>)}
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default HomePage5;
